/**
 * @generated SignedSource<<bd3131331d907c90366a8e8490f94490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberGroupEventsListItemFragment$data = {
  readonly datetimeRange: ReadonlyArray<string>;
  readonly hasViewerRSVPd: boolean;
  readonly id: string;
  readonly name: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrenceAttendingButtonFragment" | "RSVPToEventButtonFragment">;
  readonly " $fragmentType": "MemberGroupEventsListItemFragment";
};
export type MemberGroupEventsListItemFragment$key = {
  readonly " $data"?: MemberGroupEventsListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberGroupEventsListItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberGroupEventsListItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datetimeRange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasViewerRSVPd",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RSVPToEventButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OccurrenceAttendingButtonFragment"
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};

(node as any).hash = "f6536d7a34e3a7215afa77c85521b019";

export default node;
